interface InputObject {
  [key: string]: any;
}

export function replaceNullOrUndefined(obj: InputObject, replaceBy = '-'): InputObject {
  const result: InputObject = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      let value = obj[key];
      if (typeof value === 'object' && value !== null) {
        value = replaceNullOrUndefined(value);
      } else if (value === undefined || value === null || value === '') {
        value = replaceBy;
      }
      result[key] = value;
    }
  }
  return result;
}
